export const MAX_PHOTOS = 12;

export const PHOTO_PACKS = [
  {
    id: "pack-2",
    label: "Pack 2 imanes",
    qty: 2,
    price: 550,
  },
  {
    id: "pack-4",
    label: "Pack 4 imanes",
    qty: 4,
    price: 1000,
  },
  {
    id: "pack-8",
    label: "Pack 8 imanes",
    qty: 8,
    price: 1800,
  },
  {
    id: "pack-12",
    label: "Pack 12 imanes",
    qty: 12,
    price: 2400,
  },
];
export const VALID_PACK_QTYS = [2, 4, 8, 12];